module.exports = __webpack_public_path__ + "img/teddi-blue.1a7b45e0.svg";